/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AssetListRefreshRunReportDto } from './AssetListRefreshRunReportDto';

export type AssetListRefreshRunDto = {
    executionEndDate?: number;
    executionStartDate: number;
    status: AssetListRefreshRunDto.status;
    summary?: AssetListRefreshRunReportDto;
};

export namespace AssetListRefreshRunDto {

    export enum status {
        PENDING = 'PENDING',
        SUCCESS = 'SUCCESS',
        RUNNING = 'RUNNING',
        FAILURE = 'FAILURE',
    }


}
